import request from '@/axios'

export function clientList (payload,page = 1, customer_id, params, limit = 10) {
  return request({
    url: `/clientUser/list/${customer_id}?page=${page}&limit=${limit}`,
    method: 'POST',
    params,
    data:payload
  })
}
export function getPersonaDetails () {
  return request({
    url: '/clientUser/list/persona',
    method: 'GET'
  })
}
export function createClient (payload, customer_id) {
  return request({
    url: `/clientUser/create/${customer_id}`,
    method: 'POST',
    data: payload
  })
}
export function Clienttoogle (payload) {
  const customer_id = localStorage.getItem('customer_id')
  return request({
    url: `/clientUser/toggle/${customer_id}`,
    method: 'POST',
    data: payload
  })
}

export function updateClient (client_id, payload, customer_id) {
  return request({
    url: `/clientUser/edit/${client_id}/${customer_id}`,
    method: 'POST',
    data: payload
  })
}


export function ClientDetails (client_id, customer_id) {
  return request({
    url: `/clientUser/show/${client_id}/${customer_id}`,
    method: 'GET'
  })
}

export function deleteClient (deletetingId,customerId) {
  return request({
    url: `/clientUser/delete/${customerId}`,
    method: 'POST',
    data:deletetingId
  })
}
export function createMinor (payload, client_id,customer_id) {
  return request({
    url: `clientUser/create/minor/${client_id}/${customer_id}`,
    method: 'POST',
    data:payload
  })
}
export function getFilterList (query) {
  return request({
    // url:`filter/filterlist/${query}`,
    // method:'GET'
    url:'/clientUser/list',
    params:query,
    method:'GET'
  })
}

export function bulkUpdateApi (payload) {
  return request({
    url: 'clientUser/bulk_update',
    method: 'PUT',
    data:payload
  })
}
// export function user_list (schoolId, query) {
//   return request({
//     url: `/operationalUser/list/${schoolId}?${query.limit}?page=${query.page}`,
//     method: 'GET'
//   })
// }

// export function create_user (school_id, query) {
//   return request({
//     url: `/operationalUser/create/${school_id}`,
//     method: 'POST',
//     data: query
//   })
// }

// export function edit_user (operations_user_id) {
//   return request({
//     url: `/operationalUser/show/${operations_user_id}`,
//     method: 'GET'
//   })
// }


// export function update_user (operations_user_id, query) {
//   return request({
//     url:`operationalUser/inlineEdit/${operations_user_id}`,
//     method: 'POST',
//     data: query
//   })
// }

// export function delete_users (payload) {
//   return request({
//     url: '/operationalUser/delete',
//     method: 'POST',
//     data: payload
//   })
// }
export function bulkEmailApi (payload) {

  return request({

    url: '/clientUser/bulk_email/',

    method:'POST',
    data:payload
  })
}

export function filterStudentName (customer_id, payload, page_number = 1) {
  return request({
    url: `/clientUser/v2/list/${customer_id}?page=${page_number}`,
    method: 'POST',
    data: payload
  })
}

export function sendInvitation (customer_id,client_id) {
  return request({
    url: `/clientUser/invitation/${customer_id}/${client_id}`,
    method:'GET',
  })
}
export function SinglefileUploadApi (payload) {
  return request({
    url: '/clientUser/file/create',
    method: 'POST',
    data:payload
  })
}
export function SinglefileDeleApi (payload) {
  return request({
    url: 'clientUser/file/delete',
    method: 'DELETE',
    data:payload
  })
}

export function fetchClientBySearch (payload,query_page,query) {
  return request({
    url: `clientUser/global_search?attribute=${query.attribute}&direction=${query.direction}&field_type=${query.field_type}&page=${query_page.current_page}`,

    method: 'POST',
    data:payload
  })
}